$(document).ready(function () {
	// ドロワーメニュー
	$(window).on("load resize", function () {
		var width = $(window).width();
		$('.lp_header_container_drawer').off('click');
		if (width <= 768) {
			$('.lp_header_container_drawer').on('click', function () {
				if ($(this).hasClass('open')) {
					$(this).removeClass('open');
					$('body').removeClass('layer');
					$('html').removeClass('layer');
					$('.lp_header_container_product').removeClass('open');
					$('.lp_header_drawer').stop().slideUp();
				} else {
					$(this).addClass('open');
					$('body').addClass('layer');
					$('html').addClass('layer');
					$('.lp_header_container_product').addClass('open');
					$('.lp_header_drawer').stop().slideDown();
				}
			});
			$('.lp_header_drawer_container a').on('click', function () {
				$('.lp_header_container_drawer').removeClass('open');
				$('body').removeClass('layer');
				$('html').removeClass('layer');
				$('.lp_header_container_product').removeClass('open');
				$('.lp_header_drawer').stop().slideUp();
			});
		} else {
			$('.lp_header_container_drawer').on('click', function () {
				if ($(this).hasClass('open')) {
					$(this).removeClass('open');
					$('body').removeClass('layer');
					$('html').removeClass('layer');
					$('.lp_header_container_text').stop().fadeOut();
					$('.lp_header_drawer').stop().slideUp();
				} else {
					$(this).addClass('open');
					$('body').addClass('layer');
					$('html').addClass('layer');
					$('.lp_header_container_text').stop().fadeIn();
					$('.lp_header_drawer').stop().slideDown();
				}
				$('.lp_header_drawer_container a').on('click', function () {
					$('.lp_header_container_drawer').removeClass('open');
					$('body').removeClass('layer');
					$('html').removeClass('layer');
					$('.lp_header_container_text').stop().fadeOut();
					$('.lp_header_drawer').stop().slideUp();
				});
			});
		}
	});

	// ScrollReveal
	ScrollReveal().reveal('.fade', {
		duration: 2000
	});

	ScrollReveal().reveal('.lp_feature_point_main_item_img_02', {
		duration: 2000
	});

	ScrollReveal().reveal('.lp_feature_point_main_item_img_02_mark', {
		delay: 1000,
		duration: 2000
	});

	// 動画の自動再生
	function playVideos(videos) {
		const startPosition = $(window).scrollTop() + $(window).height();
		videos.each(function (index) {
			if (startPosition > $(this).offset().top) {
				$(this).get(0).play();
			}
		});
	}
	$(window).on('load', function () {
		const videos = $('video');
		if (videos.length) {
			playVideos(videos);
			$(window).on('scroll', function () {
				playVideos(videos);
			});
		}
	});

	// スムーススクロール
	$('a[href^="#"]').off();
	var headerHeight = $('header').outerHeight();
	var urlHash = location.hash;
	if (urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function () {
			var target = $(urlHash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
		}, 100);
	}
	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var target = $(href);
		var position = target.offset().top - headerHeight;
		$('body,html').stop().animate({
			scrollTop: position
		}, 500);
		return false;
	});

	// レビューカルーセル
	var $track = $('.lp_reviews_carousel_track');
	var scrollAmount = 320;

	$('.lp_reviews_carousel_prev').on('click', function () {
		$track.animate({
			scrollLeft: $track.scrollLeft() - scrollAmount
		}, 300);
	});

	$('.lp_reviews_carousel_next').on('click', function () {
		$track.animate({
			scrollLeft: $track.scrollLeft() + scrollAmount
		}, 300);
	});
});
